export default {"src":"/_next/static/media/logoMedicine.c384dee8.svg","height":73,"width":520,"blurWidth":0,"blurHeight":0};